<template>
  <!-- 产品 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          产品 <span class="low-title">(设备模型)</span>
        </div>
      </div>
      <div class="main-center h72">
        <v-button
          class="mr10"
          type="primary"
          name=""
          @click="showNewProductModel"
          >创建产品</v-button
        >
        <v-input v-model="searchKey" class="mr10" placeholder="请输入产品KEY"></v-input>
        <v-input v-model="searchName" placeholder="请输入产品名称"></v-input>
        <v-button class="ml10" type="primary" name="" @click="handleSearch">查询</v-button>
        <v-button class="" type="info" name="" @click="clear">重置</v-button>
      </div>
      <v-tabs v-model="activeName" size="S" class="tabs-btns" type="card" @tab-click="handleProductTypeChange">
        <v-tab-pane label="全部" value="">&nbsp;</v-tab-pane>
        <v-tab-pane v-for="item in productOptions" :key="item.type" :label="item.name" :value="item.type">&nbsp;</v-tab-pane>
      </v-tabs>
      <div>
        <vxe-table
          row-id="id"
          :data="table"
          align="left"
          :row-style="setRowClass"
        >
          <vxe-table-column
            field="product_name"
            show-overflow
            min-width="120"
            title="产品名称"
          ></vxe-table-column>
          <vxe-table-column
            field="product_type"
            show-overflow
            min-width="120"
            title="产品类型"
          ></vxe-table-column>
          <vxe-table-column
            field="link_type"
            show-overflow
            min-width="120"
            title="连接类型"
          ></vxe-table-column>
          <vxe-table-column
            field="auth_style"
            show-overflow
            min-width="120"
            title="认证方式"
          ></vxe-table-column>
          <vxe-table-column
            field="publish_statusView"
            show-overflow
            min-width="60"
            title="发布状态"
          ></vxe-table-column>
          <vxe-table-column
            field="created_at_str"
            show-overflow
            min-width="120"
            title="创建时间"
          ></vxe-table-column>
          <vxe-column title="操作" min-width="140">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn1"
                  slot="reference"
                  @click="openViewModel(slotProps.row)"
                  >查看</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn2"
                  slot="reference"
                  @click="routerToDevice(slotProps.row)"
                  >管理设备</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn3"
                  slot="reference"
                  @click="openDelModel(slotProps.row)"
                  >删除</v-button
                ></span
              >
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination
        v-if="total"
        @change-page="changePage"
        @change-size="changeSize"
        :total="total"
        name="pagebasic"
        is-show-total
        is-change-size
        is-input-page
        :current-page="this.currentPage"
      ></v-pagination>
    </div>

    <NewProduct
      :showInputDialog.sync="NewProductloading"
      ref="NewProduct"
      @getData="getData"
    ></NewProduct>
    <Del
      :showInputDialog.sync="Delloading"
      ref="Del"
      @getData="getData"
      :productId="productId"
    ></Del>
  </div>
</template>

<script>
// const PRODUCTTYPE = {}
import NewProduct from "@/components/product/new-product.vue";
import Del from "@/components/product/del.vue";
import { AUTH_STYLE, LINKTYPE } from "@/common/libs/Contains";
import { copy } from "@/common/libs/utils";

export default {
  components: { NewProduct, Del },
  data() {
    return {
      NewProductloading: false,
      productId: "",
      Delloading: false,
      currentPage: 1,
      // searchData: "",
      pageSize: 10,
      table: [],
      searchKey: "",
      searchName: "",
      total: 0,
      PRODUCTTYPE: {},
      activeName: '',
      productOptions: [],
      rules: {
        searchData: copy([
          {
            type: "inputNameInput",
          },
        ]),
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$getData("/td/td-iot-api/iot/product/types/v1", false).then(
        (res) => {
          let code = +res.code;
          if (code === 0) {
            this.productOptions = Object.assign([], res.data);
            res.data.map((item) => {
              let key = item.type;
              this.PRODUCTTYPE[key] = item.name;
            });
          } else {
            this.$message.error(res.msg);
          }
          this.getData();
        }
      );
    },
    setRowClass({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "background: #fafafa";
      }
    },
    clear() {
      this.searchKey = "";
      this.searchName = "";
      this.changePage(1);
    },
    handleSearch() {
      this.changePage(1);
    },
    async getData() {
      const subData = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        product_key: this.searchKey,
        product_name: this.searchName,
        app_id: sessionStorage.getItem("appid") || "",
        product_type: this.activeName
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/product/page/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.table = res.data.list;
        this.total = res.data.page.total || 0;
        this.table.map((item) => {
          item.product_type = this.PRODUCTTYPE[item.product_type];
          // item.check_level = CHECHLEVEL[item.check_level]
          item.auth_style = AUTH_STYLE[item.auth_style];
          item.link_type = LINKTYPE[item.link_type];
          item.publish_statusView =
            item.publish_status === 1 ? "已发布" : "未发布";
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },

    handleProductTypeChange(tab) {
      this.activeName = tab.value
      this.getData();
    },

    searchdata() {
      this.getData();
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1;
      this.getData();
    },
    showNewProductModel() {
      this.NewProductloading = !this.NewProductloading;
    },
    openDelModel(row) {
      this.productId = row.id;
      this.Delloading = !this.Delloading;
    },
    openViewModel(row) {
      //跳转路由-该产品的详情页面
      this.$router.push({
        name: "/deviceInfo-manage/product-details-info",
        query: { name: row.product_name, id: row.id, key: row.product_key },
      });
    },
    routerToDevice(row) {
      //跳转到设备管理页面，将key值传过去，页面筛选出该产品中的设备
      this.$router.push({
        name: "/deviceInfo-manage/device-list-info",
        query: { key: row.product_key },
      });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
.low-title {
  font-size: 18px;
}
.tabs-btns.v-tabs {
  .tab-nav--card {
    margin-bottom: 0;
  }
  .tab-pane-wrapper {
    height: 0;
  }
}

</style>

